import React from 'react';
import styled from 'styled-components';
import { COLORS } from '../../constants';

type LineProps = {
  width?: number;
  height?: number;
  color?: string;
};

export const Line = ({
  width = 215,
  height = 2,
  color = COLORS.RED_LINE,
}: LineProps) => <LineElement $width={width} $height={height} $color={color} />;

const LineElement = styled.div<{
  $width?: number;
  $height?: number;
  $color?: string;
}>`
  width: ${props => `${props.$width}px`};
  height: ${props => `${props.$height}px`};
  background: ${props => props.$color};
`;
